/*
@file-overview

- This service was brougth over from AEM wcax-commons repo

- Contains the methods used for handling actions for adding/Updating/Removing products from /cart

*/
import { Injectable, NgZone } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { retry } from 'rxjs/operators';

import { CommonService } from './common.service';
import { AemService } from './aem.service';
import { EnviormentConfig } from '../wcax-env-config';
import { UserInfoService } from './user-info.service';

import { UtilService } from './util.service';

import { IConfigObj, ISnsInfoObj, QtyStepperOptions} from '../models/data.model';

import {map , catchError} from 'rxjs/operators';


// jQuery
declare let $: any;

@Injectable()
export class CartV2Service {
  cartbaseUrl: string='';
  cartUrl: string;
  guestCartUrl: string;
  itemsUrl: string;
  orderItemsUrl: string;
  private cartEditOrderUrl = '';
  private config = EnviormentConfig;

  private _httpOptions: any;

  // this variable will be used when local storage is disabled
  private _abCart = '';

  public objRefreshInterval;

  public currentEnv = '';

  constructor(
    public _http: HttpClient,
    public _commonService: CommonService,
    public _aemService: AemService,
    public _userInfoService: UserInfoService,
    public _utilService: UtilService,
    zone: NgZone
    )
  {
      this.currentEnv = this._commonService.getCurrentEnviorment();
      this.cartUrl = this.config[this.currentEnv].cartAPIDetails.cartV2API;
      this.guestCartUrl = this.config[this.currentEnv].cartAPIDetails.apimBasePath+this.config[this.currentEnv].cartAPIDetails.guestCartBasePath;
      this.cartEditOrderUrl = this.config[this.currentEnv]?.cartAPIDetails?.editCartAPI;
      this.itemsUrl = 'items';
      this.orderItemsUrl = 'orderItems';
  }

     /*
     * This function returns headers common for all the cart v2 api calls
     */
    public getHeaders(mode: string, configObj?: IConfigObj, isGuestAddToCart?: boolean, isSelectiveCartMode?: boolean) {
        let subscriptionKey = '';
        const _this = this;

        if (this._aemService.isAllowWiremockService() && (mode === 'record' || mode === 'playback')) {
            subscriptionKey = this._aemService.getWcaxXapiApimKey();
        } else if(configObj?.programType === '1P_SNS') {
            subscriptionKey = _this.config[this.currentEnv]?.snsConfig.apimSubscriptionKeyValue;
        } else if(configObj?.appName === '1P_OA') {
            subscriptionKey = _this.config[this.currentEnv]?.domsApiDetails.subscriptionKey.value;
        } else {
            subscriptionKey = _this.config[this.currentEnv]['cartAPIDetails']['subscriptionKeyV2']['value'];
        }

        const defaultHeaders = {
            'ocp-apim-subscription-key': subscriptionKey,
            'Authorization': 'Bearer ' + _this._userInfoService.getSWY_SHOP_TOKEN(),
        };
        
        let additionalHeaders = {};
        
        if (configObj?.programType === '1P_SNS') {
            additionalHeaders = {
                'Content-Type': 'application/vnd.safeway.v1+json',
                'Accept': 'application/vnd.safeway.v1+json',
                'x-swy-date': new Date().toUTCString(),
                'x-swy-banner': _this._userInfoService.getBanner(),
                'x-swy-client-name': 'web-portal/mobile',
                'subscriptionsource': 'onetimeadd',
                'x-swy-correlation-id': _this._userInfoService.getUUID() ?? '',
            };
        } else if (configObj?.appName === '1P_OA') {
            additionalHeaders = {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Channel-Type': 'web',
            };
        } else if (isGuestAddToCart) {
            delete defaultHeaders['Authorization'];
            additionalHeaders = {
                'Sort-Order': 'date',
                'x-swy-client-id' : 'web-portal',
               
            };
        } else {
            additionalHeaders = {
                'Content-Type': 'application/json',
                'Sort-Order': 'date',
                'slotsRequired': 'true',
                'ocp-apim-trace': `${this._aemService.getCartApimTrace()}`
            };
        }

        if (isSelectiveCartMode === true) {
            additionalHeaders = {
                ...additionalHeaders,
                'Selectivecart': 'true'
            };
        }

        return { headers: new HttpHeaders({ ...defaultHeaders, ...additionalHeaders }) };
    }

    /**
     * This function generates abs cart with additional properties for viewModel
     * @param response
     * @param storeId
     * @param channel
     **/
    public generateAbsCart(response, storeId?: string, channel?: string) {
        let cartItems, cartPrice, cartQty;
        const _this = this;
        const isWYSIWYGEnabled = response['isWYSIWYGEnabled'];

        if (response['cartItemsList']) {
            cartItems = response['cartItemsList'];
        } else if (response['orderItems']) {
            cartItems = response['orderItems'];
        } else {
            cartItems = undefined;
        }

        
        if (response['wysiwygOrderSummary']) {
            cartPrice = _this._commonService.isEmpty(response['wysiwygOrderSummary'].totalEstimatedPrice) === false
                ? 0.00 : response['wysiwygOrderSummary'].totalEstimatedPrice;
            cartQty= !_this._commonService.isEmpty(response['wysiwygOrderSummary'].totalItemQuantity)? 0: response['wysiwygOrderSummary'].totalItemQuantity;
        } else {
            cartPrice = _this._commonService.isEmpty(response['summary'] && response['summary'].transactionTotal) === false
                ? 0.00 : response['summary'].transactionTotal;
            cartQty = !_this._commonService.isEmpty(response['summary'] && response['summary'].totalItemQuantity)? 0: response['summary'].totalItemQuantity;
        }
        

        const { cartItemsList, ...otherCartProperties } = response;

        const objCart = {
            ...otherCartProperties,
            'cartItems': cartItems,
            'branchId': storeId ? storeId : _this._userInfoService.getShopStoreId(),
            ...(response['guestCartId'] ? { 'guestCartId': response['guestCartId'] } : {}),
            'orderNumber': _this._commonService.checkPendingOrder()?_this._aemService.getOrderNumberCookie():'',
            'isWYSIWYGEnabled': isWYSIWYGEnabled,
            'channel': channel ? (channel.toString() === 'dug' ? 'pickup' : channel) : _this._userInfoService.getUserChannel(),
            erumsStore: true,
            cartPrice,
            cartQty
        };

        if (response.hasOwnProperty('isMTOOrder')) {
            objCart['isMTOOrder'] = response['isMTOOrder'];

            if (objCart['isMTOOrder']) {
                objCart['mtoMaxPrepTime'] = response['mtoMaxPrepTime'];
            }
        }

        return objCart;
    }

    public setCartIdObjV2 = function(cname, cartListObj) {
        const cartString = JSON.stringify(cartListObj);

        if (this._utilService.isLSCompatible()){
            localStorage.setItem(cname, cartString);
        } else {
            this._utilService.setCookie(cname, cartString, -1);
        }
      };

    /**
     * This function updates cartId in cartId local storage
     * if cartId object empty them invalidatesCartId (deletes cartId local storage)
     **/
    public updateCartIdFromResponse(cartIdObj) {
        cartIdObj && Object.keys(cartIdObj).length > 0 ? this.setCartIdObjV2('cartId', cartIdObj)
        : this.invalidateCartId();
    }

    /* invalidate cart id */
    public invalidateCartId() {
        this._commonService.removeCartId('cartId');
    }

    /**
     * This method will return the final API url based on the mockinator flag and its respective modes.
     * @param endpoint - The endpoint to be called.
     * @param isEditOrderFlow - boolean value to check edit order flow
     * @param programType - current programType
    **/

    private generateApiUrl(
        endpoint: string,
        isEditOrderFlow = false,
        configObj?: IConfigObj,
        isGuestAddToCart?: boolean,
        isGuestCartCall?: boolean
    ): string {
        const mode = this._utilService.getParams('mode');
        const wiremock = this.config[this.currentEnv]?.wiremockAPIDetails;
        const snsUrl = this.config[this.currentEnv]?.snsConfig?.url;
        const domsUrl = this.config[this.currentEnv]?.domsApiDetails?.url;
        const baseDomain = configObj?.programType === 'weeklyAd'
            ? this.config[this.currentEnv]?.baseURL?.replace('{banner}', this._userInfoService.getBanner())
            : '';
        let url = '';

        // Helper to build base cart URL
        const getBaseCartUrl = () =>
            isGuestAddToCart ? this.guestCartUrl + 'cart/' : this.cartUrl;

        // Helper to build guest cart endpoint
        const getGuestCartEndpoint = () => {
            if (endpoint === 'preferences' || isGuestCartCall) {
                return `${this.guestCartUrl}${endpoint}`;
            }
            return `${this.guestCartUrl}cart/${endpoint}`;
        };

        // Wiremock logic
        if (wiremock?.allowWiremockService) {
            const recorderBase = wiremock.recorderBaseUrl;
            const playbackBase = wiremock.playbackBaseUrl;
            let recorderUrl = '', playbackUrl = '';

            if (configObj?.programType === '1P_SNS') {
                recorderUrl = `${recorderBase}${snsUrl}${endpoint}`;
                playbackUrl = `${playbackBase}${snsUrl}${endpoint}`;
            } else if (configObj?.appName === '1P_OA') {
                recorderUrl = `${recorderBase}${domsUrl}${endpoint}`;
                playbackUrl = `${playbackBase}${domsUrl}${endpoint}`;
            } else {
                const baseCartUrl = getBaseCartUrl();
                recorderUrl = `${recorderBase}${baseCartUrl}${endpoint}`;
                playbackUrl = `${playbackBase}${baseCartUrl}${endpoint}`;
            }

            if (mode === 'record') {
                url = isEditOrderFlow
                    ? `${recorderBase}${this.cartEditOrderUrl}${endpoint}`
                    : recorderUrl;
            } else if (mode === 'playback') {
                url = isEditOrderFlow
                    ? `${playbackBase}${this.cartEditOrderUrl}${endpoint}`
                    : playbackUrl;
            } else {
                // Fallback to normal API URLs
                if (isEditOrderFlow) {
                    url = `${this.cartEditOrderUrl}${endpoint}`;
                } else if (configObj?.programType === '1P_SNS') {
                    url = `${snsUrl}${endpoint}`;
                } else if (configObj?.appName === '1P_OA') {
                    url = `${domsUrl}${endpoint}`;
                } else {
                    url = isGuestAddToCart ? getGuestCartEndpoint() : `${this.cartUrl}${endpoint}`;
                }
            }
        } else {
            // Non-wiremock logic
            if (isEditOrderFlow) {
                url = `${this.cartEditOrderUrl}${endpoint}`;
            } else if (configObj?.programType === '1P_SNS') {
                url = `${snsUrl}${endpoint}`;
            } else if (configObj?.appName === '1P_OA') {
                url = `${domsUrl}${endpoint}`;
            } else {
                url = isGuestAddToCart ? getGuestCartEndpoint() : `${this.cartUrl}${endpoint}`;
            }
        }

        return baseDomain ? baseDomain + url : url;
    }

    /*
     * Creates a cart if it doesnt exists and adds a product or updates the quantuty of user cart for marketplace
     * and non marketplace products
     */
    addOrUpdateProductQuantity(product, pId, quantity, isBatchAdd, sellerId, isLBProduct = false, snsInfoObj: ISnsInfoObj, configObj: IConfigObj, isGuestAddToCart = false, qtyStepperOptions: QtyStepperOptions = null, entryId: number, isSelectiveCartFlow = false) {
        let reqBody;
        let url = '';
        const isEditOrderFlow = this._commonService.checkPendingOrder() ? true : false;

        if(configObj?.appName === '1P_OA') {
            // Handle 1P_OA specific logic here
             const currentOrderData = this._commonService.orderAmendsCurrentOrderData;
            if (this._commonService.isEmpty(currentOrderData)) {
                return throwError(() => new Error('No current order data available'));
            }

            reqBody = this.getRequestPayloadForOrderAmendsOTA({product, currentOrderData, quantity, isLBProduct});
            url = this.generateApiUrl('/manageOrderItem', false, configObj, isGuestAddToCart);

        } else {
            let cartItemsList: any;

            if (isBatchAdd) {
                cartItemsList = quantity;
            } else {
                let obj = {itemId: pId, [isLBProduct ? 'selectedWeight' : 'qty']: quantity};
                if(qtyStepperOptions) {
                    if(qtyStepperOptions.modifierOptionUPCs && qtyStepperOptions?.modifierOptionUPCs?.upcs?.length > 0) obj.modifierOptionUPCs = qtyStepperOptions.modifierOptionUPCs.upcs;
                    if(qtyStepperOptions.entryId) obj.entryId = qtyStepperOptions.entryId;
                    if(qtyStepperOptions.comments) obj.comments = qtyStepperOptions.comments;
                    if(qtyStepperOptions.options && qtyStepperOptions.options.length > 0) obj.options = qtyStepperOptions.options;
                } else {
                    if(entryId) obj.entryId = entryId;
                }

                if (isSelectiveCartFlow) {
                    obj.selectedItem = true; 
                }

                if(!this._commonService.isEmpty(snsInfoObj)) {
                    const {isChecked, selectedFrequency, isFirstTimeSnsSub} = snsInfoObj;
                    switch(isChecked) {
                        case true:
                            obj = {...obj, isFirstTimeSnsSub : isFirstTimeSnsSub, isSnsSub : true, snsFrequency: { unit : "WEEK", count : selectedFrequency} };
                        break;
                        case false:
                            obj = {...obj, isSnsSub : false};
                        break;
                        default:
                            break;
                    }
                }
                cartItemsList = [obj];
            }

            if (isEditOrderFlow){
                reqBody = JSON.stringify(
                    {
                        [isLBProduct ? 'selectedWeight' : 'quantity']: quantity,
                        isCustomizable: product?.isCustomizable,
                        multiCustomizations: product?.multiCustomizations,
                        isMtoProduct: product?.isMtoProduct,
                        ...(((qtyStepperOptions && qtyStepperOptions.entryId) || (!qtyStepperOptions && entryId)) ? { entryId: qtyStepperOptions ? qtyStepperOptions.entryId : entryId } : {}),
                        ...(qtyStepperOptions?.comments && { comments: qtyStepperOptions.comments }),
                        ...(qtyStepperOptions?.modifierOptionUPCs?.upcs?.length
                                ? { options: qtyStepperOptions.modifierOptionUPCs.upcs.map(upcId => ({ upcId })) }
                                : ( qtyStepperOptions?.options?.length
                                    ? { options: qtyStepperOptions.options }
                                    : [])
                            ),
                    }
                );
            } else {
                reqBody = this.getRequestPayLoad(configObj?.programType, cartItemsList, isGuestAddToCart);
            }

            let endpoint = '';
            const uuid = this._userInfoService.getUUID() ?? '';
            if (isEditOrderFlow) {
                const orderStoreId = this._aemService.getOrderStoredIdCookie();
                const orderNumber = this._aemService.getOrderNumberCookie();
                endpoint = `${orderStoreId}/${orderNumber}/${this.orderItemsUrl}/${pId}`;

            } else if (configObj?.programType === '1P_SNS') {
                endpoint = `/${uuid}/oneTimeItems`;
            } else {
                endpoint = this.itemsUrl;
            }

            url = this.generateApiUrl(endpoint, isEditOrderFlow, configObj, isGuestAddToCart);
        }

        return this._http.post(url, reqBody, {
            ...this.getHeaders(this._utilService.getParams('mode'), configObj, isGuestAddToCart, isSelectiveCartFlow),
            ...this.getParams(sellerId, isEditOrderFlow, configObj, '', '', '', isGuestAddToCart)
        })
        .pipe(
            map((response) => {
                if (configObj?.appName === '1P_OA') {
                    if(response && !this._commonService.isEmpty(this._commonService.orderAmendsCurrentOrderData?.orderItems)) {
                        this.refreshOrderAmendsOTAOrderData({product, quantity});
                        return response;
                    } else {
                        catchError(
                            error => this.handleError(error, configObj?.appName)
                        )
                    }
                }
                return this.transformMulticartResponse(response);
            }),
            catchError(
                error => this.handleError(error, configObj?.appName ? configObj?.appName : configObj?.programType)
            )
        );
    }

    /**
     * Updates the `orderAmendsCurrentOrderData` cache with the provided product and quantity.
     * If the product already exists in the cache, its order item is updated; otherwise, a new order item is added.
     *
     * @param {Object} product - The product object containing details such as name, UPC, price, etc.
     * @param {number} quantity - The quantity of the product to be added or updated.
     *
     * @returns {void}
     */
    private refreshOrderAmendsOTAOrderData({product, quantity}) {
        if(this._commonService.isEmpty(product)) {
            return;
        }
        
        const newOrderItem = this.getOrderItem(product, quantity);

        // Check if item already exists and add or update orderAmendsCurrentOrderData cache
        const existingItemIndex = this._commonService.orderAmendsCurrentOrderData.orderItems.findIndex(item => item.bpnNum === product.id);
        if (existingItemIndex >= 0) {
            this._commonService.orderAmendsCurrentOrderData.orderItems[existingItemIndex] = { ...this._commonService.orderAmendsCurrentOrderData.orderItems[existingItemIndex], ...newOrderItem };
        } else {
            this._commonService.orderAmendsCurrentOrderData.orderItems.push({ ...newOrderItem, isNewlyAdded: true });
        }
    };

    public getOrderItem (product, quantity): any {
        if(this._commonService.isEmpty(product)) {
            return {};
        }
        const orderItem = {
            itemName: product.name,
            itemDescription: product.name,
            itemCode:  product.upc,
            quantity: quantity ?? 0,
            quantityType: product.unitQuantity,
            itemTotal: (product.price * quantity).toFixed(2),
            bpnNum: product.id,
            isRestrictedItem: product.restrictedValue === 2,
            currency: 'USD',
            isReplenishItem: false,
            isArProduct: product.isArProduct,
            displayType: product.displayType,
            orderedWeight: quantity,
            sellByWeightIndicator: product.sellByWeight,
            pickStatus: 'IN_PROGRESS'
        };

        return orderItem;
    }

    /**
     * Generates the request payload for amending an order via OTA (Order To Amend).
     *
     * Depending on whether the product already exists in the current order, the payload will either
     * update the existing item or add a new item to the order. Handles both regular and LB (sell-by-weight) products.
     *
     *   @param product - The product to be amended or added.
     *   @param currentOrderData - The current order data containing order details and items.
     *   @param quantity - The quantity or weight to be set for the product.
     *   @param isLBProduct - A boolean indicating if the product is a sell-by-weight item.
     *   @returns The request payload object for the order amendment API. Returns an empty object if the product is empty.
     */
    private getRequestPayloadForOrderAmendsOTA({product, currentOrderData, quantity, isLBProduct}) {
        if(this._commonService.isEmpty(product)) {
            return {};
        }
        const orderItem = currentOrderData?.orderItems?.find(item => item.bpnNum === product.id);
        
        const isExistingPlacedOrderItem = !this._commonService.isEmpty(orderItem) && !orderItem.isNewlyAdded;
        const reqBody = {
            orderNumber: currentOrderData?.orderId,
            fulfillmentOrderNumber: currentOrderData?.orderId + '011',
            storeNumber: currentOrderData?.storeNumber,
            versionNumber: 1,
            requestedTs: new Date().toISOString()
        };

        if(isExistingPlacedOrderItem) {
            reqBody['items'] = [
                {
                    itemId: product.id,
                    source: "PXP", 
                    actionCode: "UPDATE"
                }
            ];
        } else {
            reqBody['items'] = [{
                itemId: product.id,
                itemDescription: product.name,
                itemCode: product.upc,
                basePrice: product.basePrice,
                price: product.price,
                pricePer: product.pricePer,
                sellByWeight: product.sellByWeight,
                restrictedValue: product.restrictedValue,
                snapEligible: product.snapEligible,
                itemSizeQty: product.itemSizeQty ?? product.dispItemSizeQty,
                displayType: product.displayType,
                unitOfMeasure: product.unitOfMeasure,
                itemPackageQty: product.itemPackageQty ?? product.dispItemPackageQty,
                isArProduct: product.isArProduct,
                isMtoProduct: product.isMtoProduct,
                basePricePer: product.basePricePer,
                source: "PXP",
                actionCode: "ADD",
                department: {
                    id: product.idOfDepartment,
                    name: product.departmentName
                },
                aisle: {
                    id: product.aisleId,
                    name: product.aisleName
                },
                shelf: {
                    id: product.idOfShelf,
                    name: product.shelfName
                }
            }]

            if(product.alcoholVolumePct != null) reqBody['items'][0]['alcoholVolumePct'] = product.alcoholVolumePct;
            if(product.containsAlcohol != null) reqBody['items'][0]['containsAlcohol'] = product.containsAlcohol;
        }
        
        if(isLBProduct) {
            reqBody['items'][0]['orderedWeight'] = quantity;
            reqBody['items'][0]['orderedQuantity'] = 1;
            reqBody['items'][0]['minWeight'] = product.minWeight;
        } else {
            reqBody['items'][0]['orderedQuantity'] = quantity;
        }

        return reqBody;
    };

    /**
     * This method will return the request payload that needs to be sent to the cart v2 APIs (Based on some enabled features)
     * @@NOTE: For now, getRequestPayLoad method is only called when wine program
     * feature is enabled i.e supports only cartCategory '1P_WINE' (For Wine Program).
     * @@TODO: If some contract changes, going forward we have to change this method to support multiple features.
     */
     private getRequestPayLoad(programType = 'abs', cartItemsList?: any, isGuestAddToCart?: boolean, apiType?: string) {
        let payload;
        let cartCategory = '';
        let storeId = '';
        const guestCartId = this.getCartDetail()?.guestCartId ?? '';
        const isB2BSite = this._userInfoService.getSiteType() === 'B';
        if(isGuestAddToCart && apiType === 'preferences'){
            
            return {
                preferenceList: [
                    {
                        cartCategory: "1P",
                        guestCartId
                    }
                ]
            }
        }
        if (isB2BSite && programType === '1P_B2B') {
            cartCategory = programType;
            storeId = this._userInfoService.getShopStoreId();
        } else {
            cartCategory = '1P_WINE';
            storeId = this._userInfoService.getWfcStoreId();
        }
        let arrPreferenceList = [];

        const defaultPreferenceList = {
            cartCategory : cartCategory,
            storeId: storeId
        }

        arrPreferenceList = [defaultPreferenceList];

        if (cartItemsList) {
            payload = {
                preferenceList: arrPreferenceList,
                cartItemsList
            };

            if (programType === '1P_SNS' || isGuestAddToCart) {
                delete payload.preferenceList;
            }

            payload['cartCategory'] = programType === 'wineshop'? cartCategory : isGuestAddToCart ? '1P' : (programType? programType:'');

        } else {
            if(isGuestAddToCart || guestCartId) {
                const guestAddToCartPreferenceList = {
                    cartCategory: '1P',
                    ...this._userInfoService.isAuthorized() && {storeId: this._userInfoService.getShopStoreId()},
                    guestCartId
                };

                arrPreferenceList = [guestAddToCartPreferenceList, defaultPreferenceList];
            }
            payload = {
                preferenceList: arrPreferenceList
            };
        }

        return payload;
    }

    /*
     * Removes product from the user cart both for marketplace and non marketplace item
     */
    removeProduct(product, productId, sellerId,  configObj: IConfigObj, isGuestAddToCart = false, entryId: number, isSelectiveCartFlow = false) {
            // if an erums store or user is in edit order flow for erums store, use eRUMS API
        let reqBody;
        const isEditOrderFlow = this._commonService.checkPendingOrder() ? true : false;

        const cartItemsList: any = [
            {
                itemId: productId
            }
        ];

        if(entryId) {
            cartItemsList[0].entryId = entryId;
        }

        if(isEditOrderFlow){
            reqBody = null;
        } else {
            reqBody = this.getRequestPayLoad(configObj?.programType, cartItemsList, isGuestAddToCart);
        }

        let endpoint = '';
        const uuid = this._userInfoService.getUUID() ?? '';
        if (isEditOrderFlow) {
            const orderStoreId = this._aemService.getOrderStoredIdCookie();
            const orderNumber = this._aemService.getOrderNumberCookie();
            endpoint =  `${orderStoreId}/${orderNumber}/${this.orderItemsUrl}/${productId}`;
        } else if(configObj?.programType === '1P_SNS') {
            endpoint = `/${uuid}/oneTimeItems`;
        } else{
            endpoint = this.itemsUrl;
        }
        const deleteItemUrl = this.generateApiUrl(endpoint, isEditOrderFlow, configObj, isGuestAddToCart);

             return this._http.request('delete', deleteItemUrl, {
                 ...this.getHeaders(this._utilService.getParams('mode'), configObj, isGuestAddToCart, isSelectiveCartFlow),
                 ...this.getParams(sellerId, isEditOrderFlow, configObj, '', '', '', isGuestAddToCart),
                 body: reqBody
             })
             .pipe (
                 map((multicartApiResponse) => {
                    return this.transformMulticartResponse(multicartApiResponse);
                 }),
                 catchError(
                    error => this.handleError(error, configObj?.appName ? configObj?.appName : configObj?.programType)
                )
             );
    }

    /*
     * Updates cart summary based on the response from the server
     */
    public updateCartSummary(response) {
        const allItems = this.mapErumsItems(response['cartItems']);

        // @@TODO - method for updating subtotal in header - not required for DFTA
        // window['AB'].CART.updateCartSummary(response['summary']);


        // @@TODO - datalayer setup

        // if (window['AB']['DATALAYER'] && !response['seller']) {
        //     window['AB']['DATALAYER'].updateCartId(response['cartId']);
        // }

        return allItems;
    }

    /*
     * This function returns common query string parameters for the api calls like serviceType, storeId, sellerId
     */
    getParams(sellerId = null, isEditOrderFlow, configObj: IConfigObj, storeId?, serviceType?, zipcode?, isGuestAddToCart?: boolean, apiType?: string) {
        //NOTE:: We will append params only to the cart APIs if the user is not in edit order flow.
        if(!isEditOrderFlow) {

            if(configObj?.programType === '1P_SNS') {
                return { params: { banner: this._userInfoService.getBanner() } }
            }

            if(configObj?.appName === '1P_OA') {
                return { params: {} }
            }

            serviceType = serviceType ? serviceType : this._userInfoService.getPreference().toLowerCase() === 'dug' ? 'Dug' : 'Delivery';

            const params = {
                'storeId': storeId ? storeId : this._userInfoService.getShopStoreId(),
                serviceType,
            };

            params['zipCode'] = zipcode ? zipcode : this._userInfoService.getShopZipcode();

            if(isGuestAddToCart) {
                const abCartObj = this.getCartDetail();
                if(apiType !== 'preferences'){
                    params['guestCartId'] = abCartObj?.['guestCartId'] ?? '';
                }
                return { params };
            }

            if (sellerId) {
                params['sellerId'] = sellerId;
            }

            const isB2BSite = this._userInfoService.getSiteType() === "B";
            let cartCategoryList = '1P,3P_MARKETPLACE,1P_Wine';

            if (isB2BSite) {
                cartCategoryList = this._commonService.getB2BCartList() ?? '1P_B2B';
            } else {
                cartCategoryList = this._commonService.getCartList() ?? cartCategoryList;
            }

            params['cartCategoryList'] =  cartCategoryList;

            return {
                params
            };
        }
    }

    /*
     * This function generates new properties for pending orders from server response
     */

    // @@TODO - do we need handle for pending Order ?
    public handleResponseForPendingOrder(response) {
        if (this._commonService.checkPendingOrder() && !this._aemService.getEditOrderOldVersion()) {

            const order = {
                ...response
            };

            if (order.hasOwnProperty('orderSummary')) {
                delete order['orderSummary'];
            }

            return {
                ...order,
                totalAmount: response['orderSummary'] ? response['orderSummary']['totalEstimatedPrice'] : null,
                subscriptionDetails: response['orderSummary'] ? response['orderSummary']['subscriptionDetails'] : null,
                totalOfferSavings: response['orderSummary'] ? response['orderSummary']['totalSavings'] : null,
                payments: response['payments'] && response['payments'].length ? order['payments'].map(payment => {

                    // subType needs to change the key name to subtype
                    const subtype = payment.subType;
                    delete payment.subType;

                    return {
                        ...payment,
                        subtype
                    };

                }) : response['payments'],
                orderSummary: {
                    ...response['orderSummary']
                },
                isWYSIWYGEnabled: response['isWYSIWYGEnabled'],
                wysiwygOrderSummary: {
                    ...response['wysiwygOrderSummary']
                }
            };
        }

        return response;
    }

    /**
     * This function serializes the multicart response into backward compatible abCart object
     * @param response
     * @param storeId
     * @param serviceType
     **/
    public transformMulticartResponse(response, storeId?: string, serviceType?: string) {
        let abCartV2;
        const cartIdObj = {};
        if ((response.carts && response.carts.length !== 0) || response.hasOwnProperty('orderItems')) {
            const carts = {};
            let arrRes = [];
            arrRes = response.hasOwnProperty('orderItems') ? [{ ...response }] : response.carts;
            arrRes.forEach((cart: any) => {
                switch (true) {
                    case (cart.cartSource === 'ABS' && (cart.cartCategory ? cart.cartCategory === '1P' : true )) || cart.hasOwnProperty('orderItems'):
                    const absCart = this.generateAbsCart(cart, storeId, serviceType);
                    carts['abs'] = absCart;
                    // push abs cartId to cartId obj
                    cartIdObj['abs'] = absCart.cartId;
                    break;
                    case (cart.cartCategory && cart.cartCategory !== '1P') || cart.hasOwnProperty('seller'):
                        const {cartItemsList, ...otherCartProperties} = cart;
                        let key = '';
                        if (cart.cartCategory === '3P_MARKETPLACE' || cart.hasOwnProperty('seller')) {
                            key = cart.seller.sellerId;
                        } else {
                            key = cart.cartCategory;
                        }
                        carts[key] = {
                            ...otherCartProperties,
                            cartItems: cartItemsList
                        };
                    // push individual seller cartId to cartId obj
                        cartIdObj[key] = cart.cartId;
                        break;
                    default:
                        console.warn('CART V2: transformMulticartResponse -- Malformed cart response');
                        break;
                }

            });
            // call updateCartIdFromResponse and pass cartIdObj to set cartId local storage
            this.updateCartIdFromResponse(cartIdObj);
            const {multiCartSummary, cart, ...otherEmpCartProperties} = this.getV2EmptyCartsLSObj(storeId, serviceType);

            abCartV2 = {
                cart: carts,
                ...(carts['abs'] ? carts['abs'] : {...otherEmpCartProperties})
            };

            // we are setting multisummary obj only when the user is not in edit order flow.
            if (!this._commonService.checkPendingOrder()) {
            const multiCartSummaryObj = {
                     finalTransactionTotal: response['multiCartSummary']['finalTransactionTotal']
                         ? response['multiCartSummary']['finalTransactionTotal'] : 0.00,
                     totalAvailableCarts: response['multiCartSummary']['totalAvailableCarts']
                         ? response['multiCartSummary']['totalAvailableCarts'] : 0,
                     totalAvailableItems: response['multiCartSummary']['totalAvailableItems']
                                             ? response['multiCartSummary']['totalAvailableItems'] : 0,
                     totalAvailableQuantity: response['multiCartSummary']['totalAvailableQuantity']
                         ? response['multiCartSummary']['totalAvailableQuantity'] : 0
                 };
                 abCartV2['multiCartSummary'] = multiCartSummaryObj;
            }
        } else {
            abCartV2 = this.getV2EmptyCartsLSObj();
            // call updateCartIdFromResponse and pass cartIdObj to set cartId local storage
            this.updateCartIdFromResponse(cartIdObj);
        }
        return abCartV2;
    }

    /*
     * This method is used to fetch specific cart from multicart response of the apis
     */
    public fetchCartDetailsFromResponse(cartDetails, cartName) {
        if (cartDetails.cart && cartDetails.cart[cartName]) {
            return cartDetails.cart[cartName];
        } else {
            if (cartName === 'abs' || (cartName === '1P_B2B' && this._commonService.checkPendingOrder() )) {
                return cartDetails;
            } else {
                console.warn('Seller cart is not available');

                return {};
            }
        }
    }

  /*
     * This method is used to get V2 empty cart obj
     */
  public getV2EmptyCartsLSObj(storeId?: string, channel?: string) {
        return {
            multiCartSummary: {
                finalTransactionTotal: 0.00,
                totalAvailableCarts: 0,
                totalAvailableItems: 0,
                totalAvailableQuantity: 0
            },
            cart: {},
            cartItems: [],
            branchId: storeId ? storeId : this._aemService.getBranchId(),
            channel: channel ? (String (channel === 'dug' ? 'pickup' : channel)) : this._aemService.getUserChannel(),
            orderNumber: this._aemService.getOrderNumberCookie(),
            erumsStore: true,
            cartPrice: 0.00,
            cartQty: 0,
            isMTOOrder: false,
            isWYSIWYGEnabled: true
        };
    }

    /*
     * Loads and populates all the cart details from the api
     */
    public getCartV2(customerId, configObj?: IConfigObj, isGuestAddToCart?: boolean) {
        const newProgramType = configObj?.programType === '1P_B2B' ? configObj.programType : 'wineshop';
        const reqBody = this.getRequestPayLoad(newProgramType ,undefined, isGuestAddToCart);
        const endpoint = isGuestAddToCart ? `carts` : `customer/${customerId}`;
        const obs = this._http.post(this.generateApiUrl(endpoint, false, configObj, isGuestAddToCart, true), reqBody, {
            ...this.getHeaders(this._commonService.getParams('mode'),configObj, isGuestAddToCart),
            ...this.getParams(null, false, configObj)
        });

        return obs.pipe(
            map((multicartApiResponse => this.transformMulticartResponse(multicartApiResponse))),
            catchError(this.handleError)
        );
    }

    // --------------------------------------------------------------------------
    /**
     * Error Handling for Methods. Returns an error when the call is not passed.
     */
    // --------------------------------------------------------------------------
    private handleError(errorResponse: HttpErrorResponse, programType: any) {
        if(programType === '1P_SNS') {
            // Call dispatchSnsOneTimeEvent with appropriate data
            this._commonService.dispatchCustomOneTimeEvent('snsOneTime','productQtyUpdateError', {}
            );
        } 
        if (!(errorResponse.error instanceof ErrorEvent) && errorResponse.error) {
            console.error(`status: ${errorResponse.status}, ${errorResponse.statusText}`);
            const errMsg = 'Apologies, our site is currently experiencing technical difficulties, please try again later.';
            return throwError(errMsg);
        }
    }

    public mapErumsItems = function(items: any[]) {

        return items
            ? items.map((item: any) => ({
                id : item.itemId,
                name : item.name,
                quantity : item.qty,
                price : item.price,
                basePrice: item.basePrice,
                pricePerUnit: item.unitPrice,
                unitType: item.unitQuantity,
                totalPrice: item.totalPrice,
                clubCardSaving: item.clubCardSaving ? item.clubCardSaving : 0,
                isAvailable: item.isAvailable ? item.isAvailable : '',
                isFound: item.isFound ? item.isFound : '',
                savings: item.savings ? item.savings : [],
                clipped: item.clipped ? item.clipped : [],
                maxPurchaseQty: item.maxPurchaseQty,
                departmentName: item.departmentName
            }))
            : [];
    };

    /**
     * Method to update store id for existing cart using Cart v2 preference API
     *
     * **/
    public updateStoreForExistingCartV2 = function(storeId, serviceType, zipcode, isGuestAddToCart = false) {
        const apiType = 'preferences';
        const url = this.generateApiUrl(apiType, false, { programType: '1P' }, isGuestAddToCart);
        const reqBody = this.getRequestPayLoad('wineshop', null, isGuestAddToCart, apiType);

        return this._http.put(url, reqBody, {
            ...this.getHeaders(this._commonService.getParams('mode'),{ programType: '1P' },isGuestAddToCart),
            ...this.getParams(null, false, { programType: '' }, storeId, serviceType, zipcode, isGuestAddToCart, apiType)
        })
        .pipe (
            map((multicartApiResponse) => {
               return this.transformMulticartResponse(multicartApiResponse, storeId, serviceType);
            }),
            catchError(this.handleError)
        );
    };

    /**
     * Returns cartName based on the programType and sellerId
     *
     * **/
     public getCartName(programType, sellerId? ) {
        let cartName;
        switch (true) {
            case (programType === 'mkp' || programType === 'mkp-carousel') && sellerId?.length > 0:
                cartName = sellerId;
                break;
            case programType === 'wineshop':
                cartName = '1P_WINE';
                break;
            case programType === '1P_SNS':
            case programType === '1P_B2B':
                cartName = programType;
                break;
            default:
                cartName = 'abs';
        }
        return cartName;
    }


    /**
     * Returns the full display name for a given cart identifier.
     *
     * @param cartName - The short identifier of the cart (e.g., '1P_WINE').
     * @returns The full name corresponding to the cart identifier, or an empty string if not matched.
     */
    public getCartFullName(cartName: string) {
        let cartFullName = '';
        switch (true) {
            case (cartName === '1P_WINE'):
                cartFullName = 'Vine and Cellar';
                break;
            default:
            break;
        }
        return cartFullName;
    }

    /**
    * Retrieves the increment price list for a given UPC.
    * @param upc The UPC of the product.
    * @returns An Observable that emits the increment price list.
    * **/
    public getIncrementPriceList(upc): Observable<any> {
        const wiremockAPIDetails = this.config[this.currentEnv]?.wiremockAPIDetails;
        const catalogConfig = this.config[this.currentEnv]?.catalogConfig;
        const mode = this._utilService.getParams('mode');
        let path = catalogConfig['apim.api.catalog.path'] + catalogConfig['apim.api.catalog.increment.price.list.endpoint'];

        // check if wiremock service is enabled
        if (wiremockAPIDetails?.allowWiremockService) {
            if (mode === 'record') {
                path = `${wiremockAPIDetails?.recorderBaseUrl}${path}`;
            } else if (mode === 'playback') {
                path = `${wiremockAPIDetails?.playbackBaseUrl}${path}`;
            }
        }

        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'ocp-apim-subscription-key': (mode === 'record' || mode === 'playback') ? wiremockAPIDetails?.subscriptionKey : catalogConfig['apim.api.brand.index.service.key']
            })
        };

        const incrementPriceListPath =  path + `?upcIds=${upc}&storeId=${this._userInfoService.getShopStoreId()}`;
        return this._http.get(incrementPriceListPath, httpOptions).pipe(retry(1));
    };

    getCartDetail(){
        const abCartString = localStorage.getItem('abCart');
        return abCartString ? JSON.parse(abCartString) : null;
    }

    /**
     * Fetches preference customizations for a given BPN and store ID.
     * @param bpn The BPN number.
     * @param storeId The store ID.
     * @returns An Observable that emits the preference customizations data.
     */
    public getPrefCustomizations(bpn: string, storeId: string): any {
        if (!bpn || !storeId) {
            console.error(`getPrefCustomizations: Missing required parameter(s). bpn: ${bpn}, storeId: ${storeId}`);
            return;
        }
        const productsApiDetails = this.config[this.currentEnv]?.productsApiDetails;
        const baseUrl = this.config[this.currentEnv]?.catalogConfig['apim.api.catalog.path'];
        const endpoint = `/product/getPrefCustomizations?bpn=${bpn}&storeId=${storeId}`;
        const url = baseUrl + endpoint;

        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'ocp-apim-subscription-key': productsApiDetails?.subscriptionKey?.value,
            })
        };

        return this._http.get(url, httpOptions);
    }
}
